<template lang="pug">
.product-stat.d-flex.flex-column.h-100.scrollable
  .sticky-top.bg-white
    .custom-header.d-flex
      //- CustomTab.flex-fill(
      //-   :tabItems='tabItems'
      //-   v-model='selectedTab'
      //- )
      button.transparent-button.no-scaling.ml-auto.mb-auto(@click='$emit(`closeButtonClicked`)')
        i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

    .d-flex.px-4.py-2.mx-3.mb-3
      .d-flex
        img.img-72.rounded-circle(src='http://placekitten.com/200/200')
        div.ml-4
          .text-medium
            | {{ product.productId }}
          .text-title
            | {{ product.productName }}
          .text-medium
            | ยอดขายรวม
            span.text-bold.ml-2
              | {{ product.total | currency }}
      .ml-auto.text-right
        //- CustomDatePicker(
        //-   v-model='filterDate'
        //-   :disabled='true'
        //- )

    .d-flex.align-items-end.px-4.pb-4.mx-3
      CustomCategoriesFilter(
        title='เลือกดูรายการตาม'
        :items='sortType'
        :showTotalButton='false'
        v-model='filterSortBy'
      )
      InputWithIconSlot.ml-auto(
        v-model='filterSearch'
        type='text' placeholder='ค้นหาด้วยชื่อ'
        width='100%'
      )
        i.fa.fa-search

    hr.m-0

  .py-2.px-3
    CustomTable(
      :columns='tableColumns'
      :data='filteredTableData'
      :showIndexes='true'
      :itemClickable='false'
    )
      //- @itemClicked='showModal'

</template>

<script>
/* eslint-disable arrow-body-style, prefer-const, no-case-declarations */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  props: {
    customer: {
      default: () => {},
    },
    product: {
      default: () => {},
    },
    ranking: {
      default: '0',
    },
  },
  watch: {
    product() {
      this.onProductUpdated();
    },
  },
  computed: {
    filteredTableData() {
      const KEYWORD = this.filterSearch.trim().toUpperCase();
      let result = this.tableData.filter((item) => {
        return (
          // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
          // && (!this.filterStatus || item.status === this.filterStatus)
          (!KEYWORD
            || item.productName.toString().toUpperCase().includes(KEYWORD)
            || item.productId.toString().includes(KEYWORD)
          )
        );
      });
      result.sort((a, b) => {
        switch (this.filterSortBy) {
          case 'AMOUNT':
            return b.amount - a.amount;
          case 'TOTAL':
            return b.total - a.total;
          case 'RECENT':
            const DATE_A = this.$moment(b.date);
            const DATE_B = this.$moment(a.date);
            const diff = DATE_A.diff(DATE_B, 'days');
            // console.log(diff);
            return diff;
          default:
            return b.total - a.total;
        }
      });
      return result;
    },
  },
  data: () => ({
    sortType: {
      AMOUNT: 'จำนวน',
      TOTAL: 'ยอดรวม',
      RECENT: 'ล่าสุด',
    },
    filterSortBy: 'AMOUNT',

    filterDate: '',
    filterSearch: '',
    tableData: [],
    tableColumns: {
      date: {
        title: 'วันที่ทำรายการ',
        align: 'left',
        type: Date,
      },
      productId: {
        title: 'รหัสสินค้า',
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      price: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
    },

    selectedItem: {},
  }),
  mounted() {
    // this.loadData();
    this.onProductUpdated();
  },
  methods: {
    onProductUpdated() {
      if (this.product) {
        this.tableData = this.product.purchases;
      }
    },
    // async loadData() {
    //   if (this.product) {
    //     this.isLoading = true;

    //     const res = await this.$api.product.productStat(this.product.id, '');
    //     if (res.status === 200) {
    //       this.tableData = res.data.data;
    //     }

    //     this.isLoading = false;
    //   }
    // },
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .product-stat {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
